module.exports = __webpack_public_path__ + "static/media/3_Foiled_04.3232a5bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_04.jpg
// module id = 1709
// module chunks = 0